import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import './ReportPage.css';

function PhishingCharacteristics() {
  const [data, setData] = useState([]);
  const { companyID } = useParams();

  useEffect(() => {
    if (companyID) {
      loadPhishingCharacteristics(companyID);
    }
  }, [companyID]);

  const loadPhishingCharacteristics = async (companyID) => {
    try {
      const response = await fetch(`/phishing-characteristics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ companyID })
      });
      if (!response.ok) throw new Error('Failed to load phishing characteristics.');
      const data = await response.json();
      setData(data);
      displayChart(data);
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error loading the phishing characteristics.');
    }
  };

  const displayChart = (data) => {
    const ctx = document.getElementById('phishing-characteristics-chart').getContext('2d');
    // Add chart.js logic here
  };

  return (
    <div>
      <h1>Phishing Characteristics</h1>
      <canvas id="phishing-characteristics-chart"></canvas>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Timestamp</th>
            <th>Sender Email</th>
            <th>Sender Domain</th>
            <th>Classification</th>
            <th>Certainty</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td>{new Date(row.timestamp).toLocaleString()}</td>
              <td>{row.senderEmail}</td>
              <td>{row.senderDomain}</td>
              <td>{row.classification}</td>
              <td>{row.certainty.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PhishingCharacteristics;
